import { ReactNode } from "react";
import { DefaultTenant, TenantContext } from "./TenantContext";

interface Props {
  children: ReactNode;
}

export const TenantProvider = ({ children }: Props) => {
  const isTenantLoading = false;
  const tenant = null;

  // useEffect(() => {
  //   const fetchTenant = async () => {
  //     setIsTenantLoading(true);
  //     try {
  //       const tenant = await TenantService.getTenant();
  //       if (tenant?.data?.tenantId) {
  //         setTenant(tenant.data);
  //       } else {
  //         setTenant(DefaultTenant);
  //       }
  //     } catch (error) {
  //       console.error(error);
  //       setTenant(DefaultTenant);
  //     } finally {
  //       setIsTenantLoading(false);
  //     }
  //   };
  //   fetchTenant();
  // }, []);

  return (
    <TenantContext.Provider
      value={{ tenant: tenant || DefaultTenant, isTenantLoading }}
    >
      {children}
    </TenantContext.Provider>
  );
};
